var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',{staticClass:"tinymce",attrs:{"init":_vm.config,"model-events":"change keydown blur focus paste","value":_vm.value,"initial-value":_vm.value},on:{"onChange":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }